import React, { useState } from 'react'
import { Col, Row } from 'antd';
import GenericModal from '../../buttons/genericModal';
import LoadingButton from '@mui/lab/LoadingButton';
import { backendPostWithoutRefresh } from '../../../helpers/callBackend';


const ReinviteTeammate = (props) => {
    const [visible, setVisible] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const onFormSubmitModal = () => {
        setSubmitting(true);
        backendPostWithoutRefresh("/api/landlord/invite/", {
            colleague_emails: [props.email],
        }).then(() => {
            setVisible(false);
            setSubmitting(false);
        }).catch(() => {
            setSubmitting(false);
        })
    }

    return (
        <GenericModal
            size="sm"
            visible = {visible}
            handleCancelModal={() => setVisible(false)}
            showModal={() => setVisible(true)}
            button={<Row> Resend </Row>}
            modalTitle={`Resend invitation`}
            modalBody={
            <Col>
                <Row>
                    Would you like to resend invitation to {props.email}?
                </Row>
                <Row>
                    <LoadingButton
                        disableElevation fullWidth size="small" type="submit" variant="contained" color="primary"
                        loading={submitting}
                        loadingPosition="start"
                        onClick={onFormSubmitModal}
                        sx={{ marginLeft: 'auto', marginRight: 'auto', fontSize: 14, marginTop: '20px', width: '150px', textTransform: 'none' }}
                    >
                        Submit
                    </LoadingButton>
                </Row>
            </Col>
            }
        />
    )
}

export default ReinviteTeammate